import { CommonEnums } from 'src/app/shared/common.enums';

export class Tgt_Inst {
    tgt_Inst_Id: number;
    dxMp_Id: number;
    dObj_Id: number;
    instNm: string;
    description: string;
    ver: string;
    nativeFlag: string;
    tgtLoadType: string;
    truncFlag: string;
    partOverwriteFlag: string;
    scdType: string;
    scdDefStartDt: string;
    scdDefEndDt: string;
    scdDefStartKey: number;
    scdDefEndKey: number;
    scdDefStartFlag: string;
    scdDefEndFlag: string;
    scdOffset: number;
    pl_Srt_Order: number;
    tgt_Srt_Order: number;
    tgtCreateFlag: string;
    pre_DCmd: string;
    post_DCmd: string;
    pre_DCmdValid_Cd: string;
    post_DCmdValid_Cd: string;
    valid_Cd: string;
    updateBy: string;
    updateDt: Date;
    primObjId: number;
    src_Multi_PrimaryKeyFlag: string;
    dist_Cmd: string;
    dist_CmdValid_Cd: string;
    conn_Id: number;
    conn_Db_Id: number;
    gen_Tab_Valid_Cd: string;
    prop_Tab_Valid_Cd: string;
    attrMapr_Tab_Valid_Cd: string;
    scdDefTerminateDt: string;
    terminateDtFlag: string;
    externalTableFlag: string;
    gcsBucketURI: string;
    gcsFileFormat: string;

    constructor() {
        this.setDefaults()
    }

    setDefaults(): void {
        this.tgt_Inst_Id = CommonEnums.defaults.LONG_VAL;
        this.dxMp_Id = CommonEnums.defaults.LONG_VAL;
        this.dObj_Id = CommonEnums.defaults.LONG_VAL;
        this.instNm = CommonEnums.defaults.STRING_EMPTY;
        this.description = CommonEnums.defaults.STRING_EMPTY;
        this.ver = CommonEnums.defaults.STRING_EMPTY;
        this.nativeFlag = CommonEnums.defaults.STRING_VAL_YES;
        this.tgtLoadType = CommonEnums.defaults.STRING_EMPTY;
        this.truncFlag = CommonEnums.defaults.STRING_VAL_NO;
        this.scdType = CommonEnums.defaults.DEFAULT_SCD_TYPE;
        this.scdDefStartDt = CommonEnums.defaults.SCD_START_DATE;
        this.scdDefEndDt = CommonEnums.defaults.DEFAULT_SCD_END_DATE;
        this.scdDefStartKey = CommonEnums.defaults.DEFAULT_INT_VAL;
        this.scdDefEndKey = CommonEnums.defaults.DEFAULT_INT_VAL;
        this.scdDefStartFlag = CommonEnums.defaults.STRING_VAL_NO;
        this.scdDefEndFlag = CommonEnums.defaults.STRING_VAL_YES;
        this.scdOffset = CommonEnums.defaults.DEFAULT_INT_VAL;
        this.pl_Srt_Order = CommonEnums.defaults.NUM_VAL;
        this.tgt_Srt_Order = 1;
        this.tgtCreateFlag = CommonEnums.defaults.STRING_VAL_NO;
        this.pre_DCmd = CommonEnums.defaults.STRING_EMPTY;
        this.post_DCmd = CommonEnums.defaults.STRING_EMPTY;
        this.pre_DCmdValid_Cd = CommonEnums.defaults.SUCCESS_CODE;
        this.post_DCmdValid_Cd = CommonEnums.defaults.SUCCESS_CODE;
        this.valid_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.updateBy = CommonEnums.defaults.STRING_EMPTY;
        this.updateDt = new Date();
        this.primObjId = CommonEnums.defaults.LONG_VAL;
        this.src_Multi_PrimaryKeyFlag = CommonEnums.defaults.STRING_VAL_NO;
        this.dist_Cmd = CommonEnums.defaults.STRING_EMPTY;
        this.dist_CmdValid_Cd = CommonEnums.defaults.SUCCESS_CODE;
        this.conn_Id = CommonEnums.defaults.LONG_VAL;
        this.conn_Db_Id = CommonEnums.defaults.LONG_VAL;
        this.gen_Tab_Valid_Cd = CommonEnums.defaults.SUCCESS_CODE;
        this.prop_Tab_Valid_Cd = CommonEnums.defaults.SUCCESS_CODE;
        this.attrMapr_Tab_Valid_Cd = CommonEnums.defaults.SUCCESS_CODE;
        this.scdDefTerminateDt = CommonEnums.defaults.STRING_EMPTY;
        this.terminateDtFlag = CommonEnums.defaults.STRING_VAL_NO;
        this.partOverwriteFlag = CommonEnums.defaults.STRING_VAL_NO;

        this.externalTableFlag = CommonEnums.defaults.STRING_VAL_NO;
        this.gcsBucketURI = CommonEnums.defaults.STRING_EMPTY;
        this.gcsFileFormat = CommonEnums.defaults.STRING_EMPTY;
    }

    static parse(tgt_InstTmp: Tgt_Inst): Tgt_Inst {
        let tgt_Inst: Tgt_Inst = new Tgt_Inst();
        tgt_Inst.copyFrom(tgt_InstTmp);
        return tgt_Inst;
    }

    getPrimaryKey(): string {
        return this.tgt_Inst_Id + '.' + this.dxMp_Id;
    }

    copy(): Tgt_Inst {
        let tgt_InstTmp: Tgt_Inst = new Tgt_Inst();

        tgt_InstTmp.tgt_Inst_Id = this.tgt_Inst_Id;
        tgt_InstTmp.dxMp_Id = this.dxMp_Id;
        tgt_InstTmp.dObj_Id = this.dObj_Id;
        tgt_InstTmp.instNm = this.instNm;
        tgt_InstTmp.description = this.description;
        tgt_InstTmp.ver = this.ver;
        tgt_InstTmp.nativeFlag = this.nativeFlag;
        tgt_InstTmp.tgtLoadType = this.tgtLoadType;
        tgt_InstTmp.truncFlag = this.truncFlag;
        tgt_InstTmp.scdType = this.scdType;
        tgt_InstTmp.scdDefStartDt = this.scdDefStartDt;
        tgt_InstTmp.scdDefEndDt = this.scdDefEndDt;
        tgt_InstTmp.scdDefStartKey = this.scdDefStartKey;
        tgt_InstTmp.scdDefEndKey = this.scdDefEndKey;
        tgt_InstTmp.scdDefStartFlag = this.scdDefStartFlag;
        tgt_InstTmp.scdDefEndFlag = this.scdDefEndFlag;
        tgt_InstTmp.scdOffset = this.scdOffset;
        tgt_InstTmp.pl_Srt_Order = this.pl_Srt_Order;
        tgt_InstTmp.tgt_Srt_Order = this.tgt_Srt_Order;
        tgt_InstTmp.tgtCreateFlag = this.tgtCreateFlag;
        tgt_InstTmp.pre_DCmd = this.pre_DCmd;
        tgt_InstTmp.post_DCmd = this.post_DCmd;
        tgt_InstTmp.pre_DCmdValid_Cd = this.pre_DCmdValid_Cd;
        tgt_InstTmp.post_DCmdValid_Cd = this.post_DCmdValid_Cd;
        tgt_InstTmp.valid_Cd = this.valid_Cd;
        tgt_InstTmp.updateBy = this.updateBy;
        tgt_InstTmp.updateDt = this.updateDt;
        tgt_InstTmp.primObjId = this.primObjId;
        tgt_InstTmp.src_Multi_PrimaryKeyFlag = this.src_Multi_PrimaryKeyFlag;
        tgt_InstTmp.dist_Cmd = this.dist_Cmd;
        tgt_InstTmp.dist_CmdValid_Cd = this.dist_CmdValid_Cd;
        tgt_InstTmp.conn_Id = this.conn_Id;
        tgt_InstTmp.conn_Db_Id = this.conn_Db_Id;
        tgt_InstTmp.gen_Tab_Valid_Cd = this.gen_Tab_Valid_Cd;
        tgt_InstTmp.prop_Tab_Valid_Cd = this.prop_Tab_Valid_Cd;
        tgt_InstTmp.attrMapr_Tab_Valid_Cd = this.attrMapr_Tab_Valid_Cd;
        tgt_InstTmp.scdDefTerminateDt = this.scdDefTerminateDt;
        tgt_InstTmp.terminateDtFlag = this.terminateDtFlag;
        tgt_InstTmp.partOverwriteFlag = this.partOverwriteFlag;

        tgt_InstTmp.externalTableFlag = this.externalTableFlag;
        tgt_InstTmp.gcsBucketURI = this.gcsBucketURI;
        tgt_InstTmp.gcsFileFormat = this.gcsFileFormat;

        return tgt_InstTmp;
    }

    copyFrom(tgt_InstTmp: Tgt_Inst): void {
        this.tgt_Inst_Id = tgt_InstTmp.tgt_Inst_Id;
        this.dxMp_Id = tgt_InstTmp.dxMp_Id;
        this.dObj_Id = tgt_InstTmp.dObj_Id;
        this.instNm = tgt_InstTmp.instNm;
        this.description = tgt_InstTmp.description;
        this.ver = tgt_InstTmp.ver;
        this.nativeFlag = tgt_InstTmp.nativeFlag;
        this.tgtLoadType = tgt_InstTmp.tgtLoadType;
        this.truncFlag = tgt_InstTmp.truncFlag;
        this.scdType = tgt_InstTmp.scdType;
        this.scdDefStartDt = tgt_InstTmp.scdDefStartDt;
        this.scdDefEndDt = tgt_InstTmp.scdDefEndDt;
        this.scdDefStartKey = tgt_InstTmp.scdDefStartKey;
        this.scdDefEndKey = tgt_InstTmp.scdDefEndKey;
        this.scdDefStartFlag = tgt_InstTmp.scdDefStartFlag;
        this.scdDefEndFlag = tgt_InstTmp.scdDefEndFlag;
        this.scdOffset = tgt_InstTmp.scdOffset;
        this.pl_Srt_Order = tgt_InstTmp.pl_Srt_Order;
        this.tgt_Srt_Order = tgt_InstTmp.tgt_Srt_Order;
        this.tgtCreateFlag = tgt_InstTmp.tgtCreateFlag;
        this.pre_DCmd = tgt_InstTmp.pre_DCmd;
        this.post_DCmd = tgt_InstTmp.post_DCmd;
        this.pre_DCmdValid_Cd = tgt_InstTmp.pre_DCmdValid_Cd;
        this.post_DCmdValid_Cd = tgt_InstTmp.post_DCmdValid_Cd;
        this.valid_Cd = tgt_InstTmp.valid_Cd;
        this.updateBy = tgt_InstTmp.updateBy;
        this.updateDt = tgt_InstTmp.updateDt;
        this.primObjId = tgt_InstTmp.primObjId;
        this.src_Multi_PrimaryKeyFlag = tgt_InstTmp.src_Multi_PrimaryKeyFlag;
        this.dist_Cmd = tgt_InstTmp.dist_Cmd;
        this.dist_CmdValid_Cd = tgt_InstTmp.dist_CmdValid_Cd;
        this.conn_Id = tgt_InstTmp.conn_Id;
        this.conn_Db_Id = tgt_InstTmp.conn_Db_Id;
        this.gen_Tab_Valid_Cd = tgt_InstTmp.gen_Tab_Valid_Cd;
        this.prop_Tab_Valid_Cd = tgt_InstTmp.prop_Tab_Valid_Cd;
        this.attrMapr_Tab_Valid_Cd = tgt_InstTmp.attrMapr_Tab_Valid_Cd;
        this.scdDefTerminateDt = tgt_InstTmp.scdDefTerminateDt;
        this.terminateDtFlag = tgt_InstTmp.terminateDtFlag;
        this.partOverwriteFlag = tgt_InstTmp.partOverwriteFlag;

        this.externalTableFlag = tgt_InstTmp.externalTableFlag;
        this.gcsBucketURI = tgt_InstTmp.gcsBucketURI;
        this.gcsFileFormat = tgt_InstTmp.gcsFileFormat;
    }

    compare(tgt_InstTmp: Tgt_Inst): string {
        let tgt_InstString: string = this.toString(false);
        let tgt_InstTmpString: string = tgt_InstTmp.toString(false);

        if (tgt_InstString != tgt_InstTmpString) {
            return tgt_InstString + ', ' + tgt_InstTmpString;
        }

        return '';
    }

    toString(isNotCompare: boolean = true): string {
        let str: string = "Tgt_Inst [tgt_Inst_Id=" + this.tgt_Inst_Id + ", dxMp_Id=" + this.dxMp_Id + ", dObj_Id=" + this.dObj_Id +
            ", instNm=" + this.instNm + ", description=" + this.description + ", ver=" + this.ver +
            ", nativeFlag=" + this.nativeFlag + ", tgtLoadType=" + this.tgtLoadType + ", truncFlag=" + this.truncFlag +
            ", partOverwriteFlag=" + this.partOverwriteFlag + ", scdType=" + this.scdType + ", scdDefStartDt=" + this.scdDefStartDt +
            ", scdDefEndDt=" + this.scdDefEndDt + ", scdDefStartKey" + this.scdDefStartKey + ", scdOffset=" + this.scdOffset +
            ", pl_Srt_Order=" + this.pl_Srt_Order + ", tgt_Srt_Order=" + this.tgt_Srt_Order + ", tgtCreateFlag=" + this.tgtCreateFlag +
            ", pre_DCmd=" + this.pre_DCmd + ", post_DCmd=" + this.post_DCmd + ", pre_DCmdValid_Cd=" + this.pre_DCmdValid_Cd +
            ", post_DCmdValid_Cd=" + this.post_DCmdValid_Cd + ", valid_Cd=" + this.valid_Cd + ", updateBy=" + this.updateBy +
            ", updateDt=" + this.updateDt + ", primObjId=" + this.primObjId + ", src_Multi_PrimaryKeyFlag=" + this.src_Multi_PrimaryKeyFlag +
            ", dist_Cmd=" + this.dist_Cmd + ", dist_CmdValid_Cd=" + this.dist_CmdValid_Cd + ", conn_Id=" + this.conn_Id +
            ", conn_Db_Id=" + this.conn_Db_Id + ", gen_Tab_Valid_Cd=" + this.gen_Tab_Valid_Cd + ", prop_Tab_Valid_Cd=" + this.prop_Tab_Valid_Cd +
            ", attrMapr_Tab_Valid_Cd=" + this.attrMapr_Tab_Valid_Cd + ", scdDefTerminateDt=" + this.scdDefTerminateDt +
            ", terminateDtFlag=" + this.terminateDtFlag + ", externalTableFlag=" + this.externalTableFlag +
            ", gcsBucketURI=" + this.gcsBucketURI + ", gcsFileFormat=" + this.gcsFileFormat;

        if (isNotCompare) {
            str += ''
        }

        str += ']';
        return str;
    }
}